import { Routes, Route, BrowserRouter } from "react-router-dom";
import React from "react";
import App from "./Pages/App";
import Home from "./Pages/Home";
import { Config } from "../config";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={Config.brochure_route} element={<App />} />
        <Route path="/Home" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
